<template>
  <div v-loading="loading" class="stat-card blue-top">
    <div class="card-header">TỔNG SỐ KHÔNG GIAN VĂN HÓA</div>
    <div class="card-body">
      <span class="value">{{ total | numberWithDelimiter }}</span>
      <span class="unit">điểm</span>
    </div>
    <div class="card-footer desc">
      Di tích, làng nghề, tâm linh, lễ hội, ...
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listPlaces } from '@/services/place'
import TYPE from '@/data/type'

export default {
  name: 'CulturalSpaceCountCard',
  filters: {
    numberWithDelimiter(val) {
      if (val === undefined || val === null) return '0'
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  data() {
    return {
      total: 0,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    culturalSpaces() {
      return TYPE.PLACES.filter((item) => item.group_type === 'cultural_space')
    }
  },
  watch: {
    language() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const placeTypes = this.culturalSpaces.map(item => item.value).join(',')
      listPlaces({
        place_types: placeTypes,
        page: 1,
        per_page: 1,
        locale: this.language
      }).then((response) => {
        if (response && response.total !== undefined) {
          this.total = response.total
        }
      }).catch((err) => {
        console.error('Failed to fetch cultural space count', err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-top: 4px solid #eaeaea;
  min-height: 125px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }

  &.blue-top { border-top-color: #3498db; }

  .card-header {
    font-size: 12px;
    font-weight: 700;
    color: #8c8c8c;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .card-body {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    .value {
      font-size: 26px;
      font-weight: 800;
      color: #2c3e50;
      margin-right: 6px;
    }

    .unit {
      font-size: 14px;
      color: #7f8c8d;
      font-weight: 500;
    }
  }

  .card-footer {
    font-size: 12px;
    font-weight: 500;
    margin-top: 4px;

    &.desc {
      color: #95a5a6;
    }
  }
}
</style>
